module.exports = __webpack_public_path__ + "static/media/product (8).559ded86.jpg";